

//////////////////////////////////////////////b2c changes ///////////////////////////////////////////////////////////////

/* eslint-disable */
import User from '../models/User'
import api from '../utils/api'

class AuthService {
  async login(user: User) {
    const res = await api.post('login', user)
    
    // ✅ Check if login was successful before accessing token
    if (res.data?.error === true || res.data?.success === false) {
      // Login failed - don't try to access token
      console.log('🔴 Login failed:', res.data?.message || 'Unknown error')
      return res
    }
    
    // ✅ Verify data exists before accessing
    if (!res.data?.data?.token) {
      console.log('🔴 Login response missing token data')
      return res
    }
    
    this.ipAddress()
    // ✅ Use localStorage (persists on refresh, but with session validation)
    localStorage.setItem('token', res.data.data.token)
    localStorage.setItem('userType', res.data.data.role)
    localStorage.setItem('refreshToken', res.data.data.refreshToken)
    return res
  }

  async loginAdmin(user: User) {
    const res = await api.post('login-admin', user)
    
    // ✅ Check if login was successful before accessing token
    if (res.data?.error === true || res.data?.success === false) {
      // Login failed - don't try to access token
      console.log('🔴 Admin login failed:', res.data?.message || 'Unknown error')
      return res
    }
    
    // ✅ Verify data exists before accessing
    if (!res.data?.data?.token) {
      console.log('🔴 Admin login response missing token data')
      return res
    }
    
    this.ipAddress()
    // ✅ Use localStorage (persists on refresh, but with session validation)
    localStorage.setItem('token-admin', res.data.data.token)
    localStorage.setItem('userType-admin', res.data.data.role)
    localStorage.setItem('refreshToken-admin', res.data.data.refreshToken)
    return res
  }
  
   async loginAffilate(user: User) { 
    const res = await api.post('login-affilate', user)
    console.log(res,"response from backend")
    
    // ✅ Check if login was successful before accessing token
    if (res.data?.error === true || res.data?.success === false) {
      // Login failed - don't try to access token
      console.log('🔴 Affiliate login failed:', res.data?.message || 'Unknown error')
      return res
    }
    
    if (res.status === 201 && res.data?.data?.token) {
      // Store affiliate specific tokens
      localStorage.setItem('token-affiliate', res.data.data.token)
      localStorage.setItem('userType-affiliate', res.data.data.role)
      localStorage.setItem('referralCode-affiliate', res.data.data.referralCode)
    }
    return res
  }

  getUser() {
    return api.get('user-info')
  }

  refreshToken(token: string) {
    return api.post('refresh-token', { token })
  }

  getToken() {
    if (window.location.pathname.includes('admin')) {
      return localStorage.getItem('token-admin')
    }
      if (window.location.pathname.includes('affilate')) {
      return localStorage.getItem('token-affiliate')
    }
    return localStorage.getItem('token')
  }
  ipAddress() {
    // ✅ FIX: Add better error handling for IP API with fallback
    api
      .get(`${process.env.REACT_APP_IP_API_URL}`)
      .then((res) => {
        localStorage.setItem('ip_address', res.data.ip)
      })
      .catch((e) => {
        console.log('IP API failed:', e.message)
        // ✅ FIX: Set fallback IP address instead of failing silently
        localStorage.setItem('ip_address', 'unknown')
      })
  }

  gett10Streams() {
    return api
      .get(`${process.env.REACT_APP_T10_STREAM}`)
  }

  getIpAddress() {
    return localStorage.getItem('ip_address') || ''
  }

  getRefreshToken() {
    if (window.location.pathname.includes('admin')) {
      const token = localStorage.getItem('refreshToken-admin')
      if (token) return token
    }
    const token = localStorage.getItem('refreshToken')
    if (token) return token

    return ''
  }

  isLoggedIn() {
    return this.getToken() ? true : false
  }
  
   isAffiliateLoggedIn() {
    const token = localStorage.getItem('token-affiliate')
    const userType = localStorage.getItem('userType-affiliate')
    return token && userType === 'affiliate'
  }

  logoutAffiliate() {
    localStorage.removeItem('token-affiliate')
    localStorage.removeItem('userType-affiliate') 
    localStorage.removeItem('referralCode-affiliate')
  }

  getSettingsList() {
    return api.get('setting-list')
  }

  saveSettingList(settingList: any) {
    return api.post('save-setting-list', { settingList })
  }

  getpymentSettingsList() {
    return api.get('payment-list')
  }
  savepaymentSettingList(settingList: any) {
    const token = this.getToken()
    return api.post(
      'save-payment-list',
      { settingList },
      {
        headers: {
           Authorization : token ? `Bearer ${token}` : '',
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      },
    )
  }

    // Payment2 methods - Simple payment handling
    getPayment2Settings() {
      return api.get('payment2-settings')
    }
  
    savePayment2Settings(paymentData: any) {
      const token = this.getToken()
      const formData = new FormData()
      
      // Add basic fields
      formData.append('option', paymentData.option)
      formData.append('transactionPassword', paymentData.transactionPassword)
      
      // Handle QR code image file
      if (paymentData.qrCodeImageFile) {
        formData.append('qrCodeImage', paymentData.qrCodeImageFile)
      }
      
      // Add option data (excluding the file)
      const optionDataCopy = { ...paymentData.optionData }
      delete optionDataCopy.qrCodeImageFile
      formData.append('optionData', JSON.stringify(optionDataCopy))
      
      return api.post('payment2-settings', formData, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'multipart/form-data',
          Accept: 'application/json',
        },
      })
    }

    /////////////////dynamic payment method setting///////////////

    savePayment2GlobalSettings(globalData: any) {
      const token = this.getToken()
      
      return api.post('payment2-global-settings', globalData, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
    }

    // New method for updating payment option status without password
    updatePaymentOptionStatus(option: string, field: string, value: boolean) {
      const token = this.getToken()
      
      return api.post('payment2-option-status', {
        option,
        field,
        value
      }, {
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
    }
     /////////////////dynamic payment method setting///////////////
}
export default new AuthService()
